module.exports = __webpack_public_path__ + "img/Privilege_and_access_Control.c8dd34df.png";